// Simple fix to prevent circular dependencies between store and reducers / actions in the new-store.

let store: any;

export const setStore = (_store: any) => {
  store = _store;
}

export const getStore = () => store;